import { useIntersectionObserver } from "react-intersection-observer-hook";
import { useEffect, useState } from "react";

export function useInView(triggerOnce?: boolean) {
    const [ref, { entry }] = useIntersectionObserver();

    const [isSeen, setIsSeen] = useState(false);
    useEffect(() => {
        if (entry?.isIntersecting && !isSeen) {
            setIsSeen(true);
        }
    }, [entry?.isIntersecting]);

    return {
        inView: triggerOnce ? isSeen : !!entry?.isIntersecting,
        ref,
    };
}
